import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import Relationship from 'facet-rest/src/domain/Relationship';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

export const Cancel = ({
  relationship,
}) => {
  const [loading, setLoading] = useState(false);
  const { displayErrorMessage } = useSnackbarContext();
  const { setModalCollection } = useModalContext();

  return (
    <FDSecondaryActionButton
      label={relationship.meta('prompt') || 'Cancel'}
      loading={loading}
      onClick={async () => {
        setLoading(true);
        try {
          const nextModalCollection = await relationship.link('related').post();
          setModalCollection(nextModalCollection);
        } catch (e) {
          if (e.errors) {
            displayErrorMessage(e, e.errors);
          } else {
            displayErrorMessage(e, 'Failed to cancel');
          }
        } finally {
          setLoading(false);
        }
      }}
      alignSelf="center"
    />
  );
};

Cancel.defaultProps = {
};

Cancel.propTypes = {
  relationship: PropTypes.instanceOf(Relationship).isRequired,
};
